import getConfig from '../Config/env'

class Urls {
  constructor(config) {
    this.config = config
  }

  getApiUrl(url,ms) {
    return `${this.config.api}/${ms}/api/v1/hecosdp/${url}`
  }

  getEnlightenApiUrl(url) {
    return `${this.config.api}/${url}`
  }
}

export default new Urls(getConfig(process.env.NODE_ENV))
